var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page about"},[_c('page-heading',[_vm._v("ABOUT")]),_vm._v(" "),_c('SectionKeyVisual'),_vm._v(" "),_c('SectionOverview'),_vm._v(" "),_c('SectionFeature'),_vm._v(" "),_c('SectionProblem'),_vm._v(" "),_c('SectionSlogan')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }